<div class="flex w-full flex-col items-start justify-start gap-10">
  <!-- Main Title - Only visible when hideTitle is false -->
  @if (!hideTitle()) {
    <h2 class="mb-8 text-3xl font-medium text-neutral-800">
      {{
        'pages.magazinesAndJournals.accordionSections.pricesAndSubscriptions'
          | translate
      }}
    </h2>
  }

  <!-- Base Rate Section -->
  @if (magazine.price?.staffelPrices?.length) {
    <div
      class="flex w-full flex-col items-start justify-between gap-5 pb-7 md:flex-row"
    >
      <div class="w-full md:w-2/5">
        <h2 class="text-lg font-semibold text-black">
          {{ 'pages.prices.sections.basePriceTitle' | translate }}
        </h2>
      </div>
      <div class="w-full md:w-3/5">
        <div>
          <div
            class="flex items-center justify-between border-t border-neutral-900/20 py-3"
          >
            <div class="text-base font-normal text-neutral-800">
              {{ 'pages.prices.sections.subscriptionPriceLabel' | translate }}
            </div>
            <div class="text-base font-normal text-neutral-800">
              {{ 'pages.prices.sections.fromPrice' | translate }}
              {{
                'pages.prices.priceExcludingVAT'
                  | translate
                    : {
                        price: formatPrice(
                          magazine.price!.staffelPrices[0].price
                        ),
                      }
              }}
            </div>
          </div>
          @if (!!magazine.price_description?.base) {
            <div
              class="border-t border-neutral-900/20 py-3 text-base leading-normal font-normal text-neutral-800"
              [innerHTML]="magazine.price_description!.base"
            ></div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Digital Package Section -->
  @if (magazine.price?.packages?.length) {
    <div
      class="flex w-full flex-col items-start justify-between gap-5 pb-7 md:flex-row"
    >
      <div class="w-full md:w-2/5">
        <h2 class="text-lg font-semibold text-black">
          {{ 'pages.prices.sections.packagesTitle' | translate }}
        </h2>
      </div>
      <div class="w-full md:w-3/5">
        <div>
          @for (pkg of magazine.price!.packages; track pkg) {
            @if (pkg.staffelPrices.length) {
              <div
                class="flex items-center justify-between border-t border-neutral-900/20 py-3"
              >
                <div class="text-base font-normal text-neutral-800">
                  {{ pkg.name }}
                </div>
                <div class="text-base font-normal text-neutral-800">
                  @if (pkg.staffelPrices.length > 1) {
                    {{ 'pages.prices.sections.fromPrice' | translate }}
                  }
                  {{
                    'pages.prices.priceExcludingVAT'
                      | translate
                        : {
                            price: formatPrice(pkg.staffelPrices[0].price),
                          }
                  }}
                </div>
              </div>
            }
          }
          @if (!!magazine.price_description?.package) {
            <div
              class="border-t border-neutral-900/20 py-3 text-base leading-normal font-normal text-neutral-800"
              [innerHTML]="magazine.price_description!.package"
            ></div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Content Integrator Access -->
  @if (magazine.price?.contentIntegrators?.length) {
    <div
      class="flex w-full flex-col items-start justify-between gap-5 pb-7 md:flex-row"
    >
      <div class="w-full md:w-2/5">
        <h2 class="text-lg font-semibold text-black">
          {{ 'pages.prices.sections.contentIntegratorsTitle' | translate }}
        </h2>
      </div>
      <div class="w-full md:w-3/5">
        <div>
          @for (
            integrator of magazine.price!.contentIntegrators;
            track integrator
          ) {
            @if (integrator.staffelPrices.length) {
              <div
                class="flex items-center justify-between border-t border-neutral-900/20 py-3"
              >
                <div class="text-base font-normal text-neutral-800">
                  {{ integrator.name }}
                </div>
                <div class="text-base font-normal text-neutral-800">
                  @if (integrator.staffelPrices.length > 1) {
                    {{ 'pages.prices.sections.fromPrice' | translate }}
                  }
                  {{
                    'pages.prices.priceExcludingVAT'
                      | translate
                        : {
                            price: formatPrice(
                              integrator.staffelPrices[0].price
                            ),
                          }
                  }}
                </div>
              </div>
            }
          }
          @if (!!magazine.price_description?.ci) {
            <div
              class="border-t border-neutral-900/20 py-3 text-base leading-normal font-normal text-neutral-800"
              [innerHTML]="magazine.price_description!.ci"
            ></div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Additional Sections -->
  @for (section of additionalSections; track section) {
    <div
      class="flex w-full flex-col items-start justify-between gap-5 pb-7 md:flex-row"
    >
      <div class="w-full md:w-2/5">
        <h2 class="text-lg font-semibold text-black">
          {{ section.title | translate }}
        </h2>
      </div>
      <div class="w-full md:w-3/5">
        <div
          class="text-base leading-normal font-normal text-neutral-800"
          [innerHTML]="section.content | translate"
        ></div>
      </div>
    </div>
  }
</div>
